var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhoorbinOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 376.9",
    style: {
      enableBackground: "new 0 0 512 376.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2980FF;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.6,13c-16.2,1.2-26.9,5.3-36.8,18.9C259,17.8,250.9,6.2,236.1,0.6c8.3,1.2,16.7,2.2,23.8,6.9 c2.7,1.8,5.1,4.1,7.7,6c0.8,0.6,2.4,1.1,3.2,0.7C280.7,9.2,290.7,10.4,301.6,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.5,179.7c-31.3-6.2-62.7,8-79,35.8c-15.5,26.4-12.4,57.2,0.8,77.2c-8.3-38.8,12.8-72,41.1-85.5 c29.6-14.2,71.4-8.2,94.9,25.7C456.9,210.6,436.6,186.1,404.5,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.2,179.7c-31.3-6.2-62.7,8-79,35.8c-15.5,26.4-12.4,57.2,0.8,77.2c-8.3-38.8,12.8-72,41.1-85.5 c29.6-14.2,71.4-8.2,94.9,25.7C189.6,210.6,169.3,186.1,137.2,179.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.1,199.1c-9.6-18.7-20.6-29.8-27.3-35.4c-7.1-5.2-13.8-10.1-20.6-15c-38.5-28.1-76.9-56.2-115.4-84.2l0,0 c-3.7-3.2-7.2-5.3-10.5-6.5c-0.3-0.1-0.6-0.3-0.9-0.5c0,0-0.1,0.1-0.1,0.1c-12.3-4.3-20.4,2.7-20.4,2.7L233.7,109l0,0 c-6.4,4.6-12.8,9.3-19.1,14c-6,4.5-12,9.1-17.9,13.7c-0.1-0.2-0.3-0.3-0.4-0.5c17.3-15.9,34.6-31.8,52-47.8 c-11.2-8.6-22.1-17-33-25.4c-11.3-8.8-20.9-9.1-32.4-0.6c-33.5,24.5-67,49-100.5,73.5c-10.1,7.3-20.1,14.7-30.2,22.1l0,0 c0,0,0,0,0,0c-0.3,0.2-0.6,0.5-1,0.7c-4.4,3.3-22.6,17.9-34.9,41.8c-17.6,36.8-17.3,73.8,1.7,111.1c7.8,15.3,18.9,28,32.6,38.3 c27.2,20.6,57.9,28.6,91.6,23.5c35.6-5.4,63.3-23.6,83.2-53.6c3.3-5.1,7.2-9.3,11.9-13c16.2-12.5,35.5-8.8,47.8,9.3 c9.8,14.4,20.7,27.6,35.2,37.4c27.5,18.7,57.8,25.6,90.3,19.3c44.2-8.5,75.1-34.3,91.2-76.3C514.4,263,511.7,230.4,496.1,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,348.4c-25.3-0.1-47.2-8.9-65.6-26.2c-10.7-10.1-17.8-22.7-24.4-35.6c-5.3-23.1-7.1-46,2.7-68.5 c5-11.5,11.7-21.8,20.7-30.6c9.3-9.2,20.1-16.3,32.4-21c10.9-4.1,22.1-6.2,33.8-6.2c52.1,0.3,94.2,42.3,94,93.8 C217.9,306.1,175.8,348.5,124.5,348.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.9,348.4c-51.7,0.2-93.9-42.1-94-94.3c-0.1-51.7,42-93.8,93.9-93.9c51.9-0.1,94.1,42,94.2,94 C483,306.2,441,348.2,388.9,348.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhoorbinOutline);
export default __webpack_public_path__ + "static/media/dhoorbin-outline.c53e98c9ce4aad75e72ead8df20e8c98.svg";
export { ForwardRef as ReactComponent };